<template>
  <div
    class="alert mbr-alert"
    role="alert"
    :class="getClasses(color, dismissible)"
  >
    <span v-if="icon" class="alert-icon mbr-alert__icon">
      <i :class="getIcon(icon)" />
    </span>
    <span class="alert-text mbr-alert__text">
      <slot />
    </span>
    <button
      v-if="dismissible"
      type="button"
      class="btn-close d-flex justify-content-center align-items-center mbr-alert__close"
      data-bs-dismiss="alert"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "MaterialAlert",
  props: {
    color: {
      type: String,
      default: "success",
    },
    icon: {
      type: String,
      default: "",
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (color, dismissible) => {
      let colorValue, dismissibleValue;

      // Heritage Hearth tones replace the Bootstrap alert-* gradients
      if (color === "danger") {
        colorValue = "mbr-alert--danger";
      } else if (color === "success") {
        colorValue = "mbr-alert--success";
      } else if (color === "warning") {
        colorValue = "mbr-alert--warning";
      } else {
        colorValue = "mbr-alert--info";
      }

      dismissibleValue = dismissible ? "alert-dismissible fade show" : null;

      return `${colorValue} ${dismissibleValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
  },
};
</script>

<style scoped>
.alert.mbr-alert {
  display: flex;
  align-items: flex-start;
  gap: var(--mbr-space-sm);
  padding: 14px var(--mbr-space-md);
  background: var(--mbr-color-tint);
  background-image: none;
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-lg);
  box-shadow: none;
  font-family: var(--mbr-font-body);
  font-size: var(--mbr-body-sm-size);
  line-height: 20px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-alert__icon {
  display: inline-flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-label);
  color: var(--mbr-color-surface);
  font-size: 10px;
}

.mbr-alert__text {
  flex: 1 1 auto;
}

.alert.mbr-alert.mbr-alert--danger {
  background: var(--mbr-color-error-container);
  border-color: transparent;
  color: var(--mbr-color-error);
}

.mbr-alert--danger .mbr-alert__icon {
  background: var(--mbr-color-error);
}

.alert.mbr-alert.mbr-alert--success {
  color: var(--mbr-color-positive);
}

.mbr-alert--success .mbr-alert__icon {
  background: var(--mbr-color-positive);
}

.alert.mbr-alert.mbr-alert--warning {
  background: var(--mbr-color-peach);
  border-color: transparent;
  color: var(--mbr-color-ink-headline);
}

.alert.mbr-alert.alert-dismissible {
  padding-right: var(--mbr-space-md);
}

.alert.mbr-alert .btn-close.mbr-alert__close {
  position: static;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  margin: -4px -6px 0 auto;
  padding: 0;
  background: var(--mbr-color-surface);
  background-image: none;
  border-radius: var(--mbr-radius-full);
  opacity: 1;
  color: var(--mbr-color-ink-secondary);
  font-size: 18px;
  line-height: 1;
}
</style>
